import { testimonials as initialTestimonials } from "@/data/dummy";
import { useRef, useState } from "react";
import { Button } from "./ui/button";
import Link from "next/link";
// import { Link } from "lucide-react";

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState(initialTestimonials);
  const [animatingCard, setAnimatingCard] = useState<number | null>(null);

  const stickyRef = useRef<HTMLDivElement>(null);

  const handleCardClick = (index: number) => {
    setAnimatingCard(index);

    setTimeout(() => {
      setTestimonials((prev) => {
        const newArr = [...prev];
        const [clicked] = newArr.splice(index, 1);
        newArr.push(clicked);
        return newArr;
      });
      setAnimatingCard(null);
    }, 600);
  };

  return (
    <section className="relative grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-4 p-8 lg:p-8 mx-2 bg-[rgb(7,85,158)] mb-30">
      <div className="absolute -top-24 left-0 w-full h-1" />

      {/* LEFT — Overlapping → Stacked */}
      <div className="relative z-10 flex -space-x-40 lg:-space-x-64 overflow:hidden">
        {testimonials.map((item, index) => {
          return (
            <div
              key={index}
              onClick={() => handleCardClick(index)}
              className="bg-[rgb(7,85,158)] h-[400px] w-[280px] lg:w-[300px]
                border-b-2 border-t-2 border-cyan-400 shadow-xl p-8
                flex flex-col justify-between cursor-pointer
                transition-all duration-700 hover:-translate-y-5"
              style={{
                marginTop: index * 16,
                zIndex: index,
                transform:
                  animatingCard === index
                    ? "translateX(-120px) translateY(-20px)"
                    : "none",
              }}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-amber-300 text-xs">
                    ⭐
                  </span>
                ))}
              </div>

              {/* Quote */}
              <p className="text-white/90 italic text-base leading-relaxed -mb-4 line-clamp-5">
                "{item.quote}"
              </p>

              {/* Footer */}
              <div className="flex flex-col items-start gap-4 pt-4 border-t border-white/30">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-cyan-300 shadow-sm"
                />
                <div>
                  <div className="font-bold text-white text-base">
                    {item.name}
                  </div>
                  <div className="text-cyan-200 font-medium text-sm">
                    {item.role}
                  </div>
                  <div className="text-white/60 text-xs">Hexad ltd</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* RIGHT — Sticky */}
      <div
        ref={stickyRef}
        className="flex flex-col justify-center space-y-6 bg-gray-50 items-center py-10 lg:p-2"
      >
        <p className="text-cyan-600 text-xs uppercase font-medium">
          Testimonials
        </p>

        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
          Trusted by Industry <span className="text-cyan-600">Leaders</span>
        </h2>

        <p className="text-gray-600 leading-relaxed text-center">
          Discover why Fortune 500 companies and growing startups choose Hexad
          as their trusted consulting partner for digital transformation and
          innovation.
        </p>

        <div className="flex items-center gap-4 pt-4">
          <Link href="/case-studies">
            <Button className="bg-cyan-600 hover:bg-cyan-700 text-white px-6 py-2">
              View Case Studies
            </Button>
          </Link>

          <Link href="/team">
            <Button
              variant="outline"
              className="border-cyan-500 text-cyan-600 hover:bg-cyan-50 px-6 py-2"
            >
              Meet Our Team
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
